import { useEffect, useState } from "react"
import { Card, CardContent, Typography, Grid, Box } from "@mui/material"
import { useApiService } from "../hooks/Api/useApiService"
import Spinner from "../UI/Spinner/Spinner"
import T from "../hooks/Language/T"

const Testamonies = () => {
  const [testamonies, setTestamonies] = useState([])
  const [loading, setLoading] = useState(true)
  const { getData } = useApiService()

  useEffect(() => {
    getData("sharie/gettestamonies").then((data) => {
      setTestamonies(data?.testamonies || [])
      setLoading(false)
    })
  }, [])

  if (loading) {
    return (
      <Box display='flex' justifyContent='center' my={4}>
        <Spinner />
      </Box>
    )
  }

  return (
    <T>
      <Box my={4} px={2} width='100%'>
        <Typography variant='h5' gutterBottom align='center'>
          What People Are Saying About Sharie
        </Typography>
        <Grid container spacing={2} width='100%' justifyContent='center' alignItems='stretch'>
          {testamonies.map((t, index) => (
            <Grid item width={"100%"} key={index}>
              <Card
                variant='outlined'
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  p: 2,
                }}
              >
                <CardContent>
                  <Typography variant='body1' gutterBottom align='center'>
                    "{t.message}"
                  </Typography>
                  <Typography variant='subtitle2' color='text.secondary' align='center'>
                    - {t.user_name || "Anonymous"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </T>
  )
}

export default Testamonies
